//=====================================================
//　ユーザー認証
//=====================================================
import { AxiosResponse } from 'axios';
import { postApiData } from './CallApi';
import { LoginStatusType } from './ConstCommon';

//ユーザー認証管理IF
export interface IFUseAuth { 
    login: ( clinicid: string, id:string, password:string, callback?:any ) => void,
    linelogin: (clinicid: string, id:string, password:string, callback?:any) => void,
    logout: (callback?:any) => void,
    getToken: () => string | null,
    getPatientNo: () => string | null,
    checkExpiresIn: () => LoginStatusType,
    isLoggedIn: () => boolean,
}

//-----------------------------------------------------
//　ユーザー認証管理
//-----------------------------------------------------
export function useAuth():IFUseAuth{
    
    //-----------------------------------------------------
    //　ログイン
    //-----------------------------------------------------
    function login( clinicId: string, id: string, password: string, callback?: any){
        let apiUrl = `/c/${clinicId}/patients/login`

        postApiData(
            apiUrl, 
            {id:id, password:password, hash:false}, 
            function(res:AxiosResponse<any>){
                if(res.status === 200 ){
                    sessionStorage.setItem('loggedIn', 'true');
                    sessionStorage.setItem('patientNo', id);
                    sessionStorage.setItem('token', res.data.accessToken);
                    sessionStorage.setItem('expiresIn', res.data.expiresIn)
                }
                if (callback){
                    callback(res);
                }
            }
        );
    }

    //-----------------------------------------------------
    //　LINEログイン
    //-----------------------------------------------------
    function linelogin( clinicId: string, id: string, password: string, callback?: any ){
        let apiUrl = `/c/${clinicId}/patients/login`

         postApiData(
            apiUrl,
            {id:id, password:password, hash:true}, 
            function(res:AxiosResponse<any>){
                if(res.status === 200 ){
                    sessionStorage.setItem('loggedIn', 'true');
                    sessionStorage.setItem('patientNo', id);
                    sessionStorage.setItem('token', res.data.accessToken);
                    sessionStorage.setItem('expiresIn', res.data.expiresIn);
                }
                if (callback){
                    callback(res);
                }
            }
        );
    }

    //-----------------------------------------------------
    //　ログアウト
    //-----------------------------------------------------
    function logout(callback?: any) {
        sessionStorage.removeItem('loggedIn');
        sessionStorage.removeItem('patientNo');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('expiresIn');
        if (callback){
            callback();
        }
    }
    
    //-----------------------------------------------------
    //　セッションストレージに保持したトークンの取得
    //-----------------------------------------------------
    function getToken(){
        //保持期間を判定
        const dt = new Date().getTime();
        const expiresIn = Number(sessionStorage.getItem('expiresIn'));

        if( dt > expiresIn ){
            //保存期間切れ
            sessionStorage.removeItem('patientNo');
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('expiresIn');
            //ログイン済みで期間切れを判断するために、ここでは'isLoggedIn'をremoveしない
            return '';
        }

        return sessionStorage.getItem('token');
    }

    //-----------------------------------------------------
    //　セッションストレージに保持した診察券番号の取得
    //-----------------------------------------------------
    function getPatientNo() {
        return sessionStorage.getItem('patientNo');
    }

    //-----------------------------------------------------
    //　ログイン期限内判定
    //-----------------------------------------------------
    function checkExpiresIn() {

         //ログインしているか
         if( isLoggedIn() ){
            //保持期間を判定
            const dt = new Date().getTime();
            const expiresIn = Number(sessionStorage.getItem('expiresIn')) ;
            if( dt > expiresIn ){       
                //ログイン期限切れ
                return LoginStatusType.LoginExpired;

            }
            //ログイン中
            return LoginStatusType.Login;

        }else{
            //ログアウト
            return LoginStatusType.LogOut;

        }
    }

  //-----------------------------------------------------
    //　ログイン済みかの判定
    //-----------------------------------------------------
    function isLoggedIn() {
        return sessionStorage.getItem('loggedIn') === "true";
    }

    return {login, logout, linelogin, getToken, getPatientNo, checkExpiresIn, isLoggedIn};

}